import AuditTask from "./AuditTask";


function AuditTaskAdmin () {

    return <AuditTask adminMode={true} />
}

export default AuditTaskAdmin;